import { Link } from "react-router-dom";
import { NewsItem } from "@/lib/webContentTypes";

const categoryColors: Record<string, string> = {
  "Noticias": "bg-sky-500",
  "Actividades": "bg-emerald-500",
  "Comunicados": "bg-amber-500",
  "Cortes programados": "bg-red-500",
  "Avisos importantes": "bg-orange-500",
};

interface Props {
  news: NewsItem;
  featured?: boolean;
}

export default function NewsCard({ news, featured = false }: Props) {
  const badgeColor = categoryColors[news.category] ?? "bg-slate-500";

  return (
    <Link
      to={`/noticias/${news.id}`}
      className={`group block rounded-2xl overflow-hidden cursor-pointer transition-transform duration-300 hover:-translate-y-1 ${
        featured ? "md:col-span-2" : ""
      }`}
    >
      <div className={`relative overflow-hidden ${featured ? "h-72 md:h-80" : "h-52"}`}>
        <img
          src={news.image}
          alt={news.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold text-white mb-2 ${badgeColor}`}>
            {news.category}
          </span>
          <h3 className={`font-bold text-white leading-snug mb-1 ${featured ? "text-xl md:text-2xl" : "text-base"}`}>
            {news.title}
          </h3>
          <p className="text-white/70 text-xs">
            {new Date(news.date).toLocaleDateString("es-CL", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        </div>
      </div>
      <div className="bg-white p-4 border border-t-0 border-slate-100 rounded-b-2xl">
        <p className="text-slate-600 text-sm leading-relaxed line-clamp-2">{news.summary}</p>
        <span className="inline-flex items-center gap-1 mt-3 text-sky-600 text-sm font-semibold group-hover:gap-2 transition-all">
          Leer más <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}
